/** @format */
import qs, { ParsedQs } from 'qs';

export function getCanonicalHref(
    hostUri: string,
    serverUrl?: string
): string | undefined {
    // If we have more than one allowed URL parameter, we need to order them to ensure
    // consistent canonical URLs
    const allowedUrlParams = ['page'];

    try {
        const isServer = typeof window === 'undefined';

        const url = isServer
            ? serverUrl ?? ''
            : window.location.href.replace(window.location.origin, '');

        // Force HTTPS for canonical URLs (SEO best practice)
        const normalizedHostUri = hostUri.startsWith('http://')
            ? hostUri.replace('http://', 'https://')
            : hostUri;

        // Remove fragment identifier (hash) from URL as canonical URLs shouldn't include them
        // as it can cause duplicate content issues
        const urlWithoutFragment = url.split('#')[0];

        const [pathname, queryString] = urlWithoutFragment.split('?');

        if (!pathname) {
            return undefined;
        }

        // Remove query parameters that are not allowed, to avoid duplicate content issues
        const params = queryString ? qs.parse(queryString) : {};
        const filteredParams = Object.entries(params).reduce<ParsedQs>(
            (filteredParams, [key, value]) => {
                if (allowedUrlParams.includes(key)) {
                    filteredParams[key] = value;
                }
                return filteredParams;
            },
            {}
        );
        const queryPart =
            Object.keys(filteredParams).length > 0
                ? qs.stringify(filteredParams, { addQueryPrefix: true })
                : '';

        const normalizedHost = normalizedHostUri.replace(/\/$/, '');
        const normalizedPath = pathname.startsWith('/')
            ? pathname
            : `/${pathname}`;

        const canonicalUrl = `${normalizedHost}${normalizedPath}${queryPart}`;

        // Validate the final URL, this will throw if invalid
        new URL(canonicalUrl);

        return canonicalUrl;
    } catch (error) {
        return undefined;
    }
}
